import dayjs from "dayjs";
import type { ConfigType } from "dayjs";

const formatDate = (date: ConfigType) => {
  if (!date) return "-";

  return dayjs(date).format("YYYY-MM-DD HH:mm");
};

export default formatDate;
